<template>
  <div
    id="movingBackground"
    :style="{
      backgroundPosition: `-${this.coordinates.x}px -${this.coordinates.y}px`,
    }"
  ></div>
</template>

<script>
export default {
  data() {
    return {
      imageSize: {
        width: 3376,
        height: 2095,
      },
      animationField: [this.imageSize],
      min: 0,
      coordinates: {
        x: 0,
        y: 0,
      },
    };
  },
  methods: {
    newCoordinates() {
      this.coordinates.x = Math.floor(
        Math.random() * (this.animationField.width - this.min + 1) + this.min
      );
      this.coordinates.y = Math.floor(
        Math.random() * (this.animationField.height - this.min + 1) + this.min
      );
    },
  },
  mounted() {
    this.animationField.width = this.imageSize.width - (window.innerWidth);
    this.animationField.height = this.imageSize.height - (window.innerHeight);
    this.newCoordinates();
    setTimeout(() => {
      this.newCoordinates();
    }, 500);
    setInterval(() => {
      this.newCoordinates();
    }, 10000);
  },
};
</script>

<style lang="scss" scoped>
#movingBackground {
  transition: background-position 9.9s ease;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  opacity: 0.2;
  background-image: url("../assets/bg.png");
  background-position: 0px 0px;
  background-attachment: fixed;
}
</style>
